
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { executeReducerBuilderCallback } from '@reduxjs/toolkit/dist/mapBuilders';

interface web3State {
  web3: any;
  isWalletConnect: boolean;
  platformTokenAmount? : any,
  unlockedVestingAmount?: any
}

const initialState: web3State = {
  web3: {},
  isWalletConnect: false,
  platformTokenAmount : 0,
  unlockedVestingAmount : 0
};



export const web3Slicer = createSlice({
  name: 'web3',
  initialState,
  reducers: {
    changeWeb3: (state, action: PayloadAction<any>) => {
      state.web3 = action.payload;
    },
    changeWalletConnect: (state, action: PayloadAction<boolean>) => {
      state.isWalletConnect = action.payload;
    },
    changePlatformTokenAmount: (state, action: PayloadAction<any>) => {
      state.platformTokenAmount = action.payload;
    },
    changeUnlockedVestingAmount: (state, action: PayloadAction<any>) => {
      state.unlockedVestingAmount = action.payload;
    },
  }
});
export const { 
  changeWeb3, 
  changeWalletConnect,
  changePlatformTokenAmount,
  changeUnlockedVestingAmount
} =
  web3Slicer.actions;

export default web3Slicer.reducer;